/**
 * Пути админки в одном месте.
 *
 * Разъехавшаяся строка не ломает сборку — она просто ведёт в NotFound, и
 * заметить это можно только руками. Поэтому пути объявлены константами, а
 * меню и роутер читают одни и те же значения.
 */
export const ROUTES = {
  login: "/login",
  dashboard: "/",
  users: "/users",
  user: (id: number | string) => `/users/${String(id)}`,
  robots: "/robots",
  robotNew: "/robots/new",
  robot: (id: number | string) => `/robots/${String(id)}`,
  robotAnalytics: (id: number | string) => `/robots/${String(id)}/analytics`,
  deposits: "/deposits",
  withdrawals: "/withdrawals",
  accruals: "/accruals",
  settings: "/settings",
  comments: "/comments",
  audit: "/audit",
  admins: "/admins",
} as const;
